import { Component, OnInit, OnDestroy, Output, EventEmitter } from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { SfDataService } from '../../services/sf-data.service';

interface AddressChangeTask {
  id: string;
  subject: string;
  accountId: string;
  accountName: string;
  createdDate?: Date;
  dueDate?: Date;
}

@Component({
  selector: 'app-sf-dashboard-address-change-tasks',
  templateUrl: './sf-dashboard-address-change-tasks.component.html',
  styleUrls: ['./sf-dashboard-address-change-tasks.component.scss'],
  standalone: false
})
export class SfDashboardAddressChangeTasksComponent implements OnInit, OnDestroy {
  private destroy$ = new Subject<void>();

  @Output() accountNameClick = new EventEmitter<string>();

  tasks: AddressChangeTask[] = [];
  loading = true;
  error = false;

  constructor(private sfDataService: SfDataService) { }

  ngOnInit(): void {
    this.loadTasks();
  }

  loadTasks(): void {
    this.loading = true;
    this.error = false;
    this.sfDataService.getAddressChangeTasks()
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (data: any) => {
          this.tasks = Array.isArray(data) ? data : [];
          this.loading = false;
        },
        error: (err) => {
          console.error('Failed to load address change tasks', err);
          this.loading = false;
          this.error = true;
          this.tasks = [];
        }
      });
  }

  formatDate(date: string | Date | undefined): string {
    if (!date) return '—';
    const dateObj = typeof date === 'string' ? new Date(date) : date;
    return dateObj.toLocaleDateString('en-US', {
      month: 'short',
      day: 'numeric',
      year: 'numeric'
    });
  }

  onAccountNameClick(accountName: string): void {
    this.accountNameClick.emit(accountName);
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
